export default "__VITE_ASSET__BTusjzUy__"